import ValueStore from "../../Common/Stores/ValueStore";

export default function createWishlistStore(initialState) {
    const store = new ValueStore();
    store.load(initialState);

    return store;
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Wishlist/Stores/WishlistStore.jsx